// extracted by mini-css-extract-plugin
export var card = "metamorphosis-card-module--card--Iwnaq";
export var content = "metamorphosis-card-module--content--pYyPS";
export var icon = "metamorphosis-card-module--icon--VViRD";
export var imgBox = "metamorphosis-card-module--img-box--pyJWV";
export var name = "metamorphosis-card-module--name--shO1k";
export var ratioClass = "metamorphosis-card-module--ratio-class--NBCtC";
export var text = "metamorphosis-card-module--text--6vtRX";